import React, { useState } from 'react';
import Modal from 'react-bootstrap/esm/Modal';
import { Button, SelectInsertEmail } from '@app/components/index';
import UserNotifyEmailService from '@app/services/userNotifyEmail.service';

const toSelectFormat = (emails) => emails.map((e) => ({ label: e, value: e }));
const toStringArray = (opts) => opts.map((o) => o.value);

function ModalNotifyEmail({ show, hideModal, tipo, emailsActivos, onGuardar }) {
    const handleClose = () => hideModal();
    const [emails, setEmails] = useState(toSelectFormat(emailsActivos));
    const [isLoading, setIsLoading] = useState(false);

    const onSubmit = () => {
        setIsLoading(true);
        UserNotifyEmailService.register({
            tipo_uxne: tipo,
            emailStr_uxne: toStringArray(emails),
            emailBool_uxne: true
        })
        .then(() => {
            handleClose();
            onGuardar();
        })
        .catch(() => setIsLoading(false));
    };

    return (
        <Modal show={show} backdrop="static" size="md" onHide={handleClose}>
            <Modal.Header closeButton>
                <div className="col-11">
                    <Modal.Title>{`Editar correos: ${tipo}`}</Modal.Title>
                </div>
            </Modal.Header>
            <div className="col-12 bg-white p-3">
                <small className="text-muted">
                  Ingrese un correo y presione
                  <strong>Enter</strong>
                  o
                  <strong>Tab</strong>
                  para agregar.
                </small>
                <div className="mt-2">
                    <SelectInsertEmail
                        value={emails}
                        onChange={setEmails}
                    />
                </div>
            </div>
            <Modal.Footer>
                <Button onClick={handleClose} theme="default">CERRAR</Button>
                <Button
                    theme="primary"
                    onClick={onSubmit}
                    isLoading={isLoading}
                    disabled={emails.length === 0}
                >
                    GUARDAR
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ModalNotifyEmail;
